import makeRequest from 'api/makeRequest';
import environment from 'environment';

/** ******* THE BELOW FUNCTIONS ARE RELATED TO THE COMMON ORDER INTERFACE SPECIFICALLY. DO NOT ADD ANOTHER FUNCTION TO THIS FILE UNLESS IT IS PART OF THE COMMON ORDER INTERFACE AND RETURNS DATA IN THE COMMON ORDER SCHEMA ******* **/

export const searchOrders = async (params) => {
  return await makeRequest(`${environment.eCommerce.ORDERS_BASE_URL}/orders`, {
    params,
  });
};

export const getOrder = async (params) => {
  return await makeRequest(`${environment.eCommerce.ORDERS_BASE_URL}/order`, {
    params,
  });
};

export const getReasons = async (params) => {
  return await makeRequest(`${environment.eCommerce.ORDERS_BASE_URL}/reasons`, {
    params,
  });
};

export const cancelOrder = async (payload) => {
  return await makeRequest(`${environment.eCommerce.ORDERS_BASE_URL}/order/cancel`, {
    method: 'post',
    data: payload,
  });
};

export const refundOrder = async (payload) => {
  return await makeRequest(`${environment.eCommerce.ORDERS_BASE_URL}/issueRefund`, {
    method: 'post',
    data: payload,
  });
};

export const issueDiscount = async (payload) => {
  return await makeRequest(`${environment.eCommerce.ORDERS_BASE_URL}/issueDiscount`, {
    method: 'post',
    data: payload,
  });
};

export const issueReplacement = async (payload) => {
  return await makeRequest(`${environment.eCommerce.ORDERS_BASE_URL}/order/issueReplacement`, {
    method: 'post',
    data: payload,
  });
};

export const canCancel = async (payload) => {
  return await makeRequest(`${environment.eCommerce.ORDERS_BASE_URL}/v2/canCancel`, {
    method: 'post',
    data: payload,
  });
};

export const canRefund = async (payload) => {
  return await makeRequest(`${environment.eCommerce.ORDERS_BASE_URL}/v2/canRefund`, {
    method: 'post',
    data: payload,
  });
};

export const canDiscount = async (payload) => {
  return await makeRequest(`${environment.eCommerce.ORDERS_BASE_URL}/v2/canDiscount`, {
    method: 'post',
    data: payload,
  });
};

export const updateOrderAddress = async (payload) => {
  const orderId = payload.orderId;

  return await makeRequest(`${environment.eCommerce.ORDERS_BASE_URL}/order/${orderId}/address`, {
    method: 'patch',
    data: payload,
  });
};

export const updateShipmentDate = async (payload) => {
  return await makeRequest(`${environment.eCommerce.ORDERS_BASE_URL}/order/shipmentDate`, {
    method: 'patch',
    data: payload,
  });
};

export const updateSubscriptionDate = async (payload) => {
  return await makeRequest(`${environment.eCommerce.SUBSCRIPTIONS_BASE_URL}/changeShipDate`, {
    method: 'patch',
    data: payload,
  });
};

export const patchOrderTags = async ({ simplrAccountId, orderId, shopName, tags }) => {
  const url = `${environment.eCommerce.ORDERS_BASE_URL}/order/tags`;
  const config = {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      simplrAccountId,
      orderId: orderId.toString(),
      shopName,
      tags,
    },
  };

  return await makeRequest(url, config);
};
